import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { PermissionCheckAddCommentQuery } from './PermissionCheckAddCommentQuery.graphql';
import type {
	PermissionCheckAddCommentQuery$data,
	PermissionCheckAddCommentQuery$variables,
} from './__generated__/PermissionCheckAddCommentQuery.graphql';

export function preloadAddCommentPermissionCheck(contentId: string) {
	return query<PermissionCheckAddCommentQuery$data, PermissionCheckAddCommentQuery$variables>({
		query: PermissionCheckAddCommentQuery,
		variables: {
			contentId,
		},
	});
}
